import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TreasureRedemption from '../../components/TreasureRedemption';
import * as redemptionActions from '../../actions/redemption';

const TreasureRedemptionContainer = props => (<TreasureRedemption {...props}/>);

const mapStateToProps = ({redemption}) => ({...redemption});

const mapDispatchToProps = dispatch => (
  {dispatch, ...bindActionCreators(redemptionActions, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(TreasureRedemptionContainer);
